<template>
  <div>
    <AppHeader style="margin-top: -20px;" :showMenu="true" :title="''">
        <template #menu>
          <ul class="list-group" style="padding: 0; color: white; background: transparent;">
              <li
                class="list-group-item"
                v-if="hasPermission(1)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleMainPage"
                  >POS</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(14)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleChangePassword"
                  >Change Password</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(15)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="getShowParked()"
                >
                  {{ this.jsonData.menu_parked }}
                </a>
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(20)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleAddCustomer"
                  >Customers</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(26)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleFindInvoice"
                  >Find invoice</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(31)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleProductReturn"
                  >Return Invoice</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(32)"
                style="
                  text-align: left;
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleReports"
                  >Reports</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(71)"
                style="
                  text-align: left;
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleSettings"
                  >Settings</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(67)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleGiftCards"
                  >GiftCards</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(68)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleShifts"
                  >Shifts</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(41)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handlePromotions"
                  >Promotions</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(44)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleUsers"
                  >Users</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(47)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleProducts"
                  >Products</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(48)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleMachines"
                  >Machines</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(53)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleMobilePaymentProvider"
                  >Mobile Payment Provider</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(56)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleSyncUra"
                  >{{ this.jsonData.sync_ura }}</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(63)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleCustomCloseCash"
                  >{{ this.jsonData.custom_close_cash }}</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(65)"
                style="
                  background-color: #656565;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#656565'"
                  href="#"
                  @click="handleProductManagement"
                  >{{ this.jsonData.product_management }}</a
                >
              </li>

              <li
                class="list-group-item"
                style="
                  background-color: #fe4435;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#fe4435'"
                  href="#"
                  @click="handleLogout"
                  >Logout</a
                >
              </li>

              <li
                class="list-group-item"
                v-if="hasPermission(45)"
                style="
                  background-color: #950b00;
                  border: solid 2px;
                  border-style: outset;
                  text-align: left;
                "
              >
                <a
                  style="color: whitesmoke"
                  onmouseover="this.style.backgroundColor='#950b00'"
                  href="#"
                  @click="handleCloseCash"
                  >{{ this.jsonData.close_cash_btn }}</a
                >
              </li>
          </ul>
        </template>
    </AppHeader>

      <div class="container" style="background-color: var(--theme-bg-end);">
        <div class="split80 left" style="padding-top: 80px;">
       <div class="row topnav" style="padding-left: 15px">
         <div class="col-sm-12" style="margin-top: 20px;">
          <qrcode-vue
            class="vue_qrcode_ref"
            style="display: none"
            v-if="efrisData.ura_qr_code"
            level="H"
            size="300"
            :value="efrisData.ura_qr_code"
          ></qrcode-vue>

          <vue-barcode
            class="vue_barcode_ref"
            style="display: none"
            v-if="currentOrderId != ''"
            :options="{ width: 3 }"
            :value="currentOrderId"
          ></vue-barcode>

          <!-- - <input type="text" ref="searchProduct" v-on:keyup.enter="getProduct(barcode2)" v-model="barcode2" id="Barcode2"

            name="Barcode2" placeholder="Enter Product Barcode"> -->
          <textarea
            style="
              float: right;
              padding: 7px;
              margin-right: 16px;
              font-size: 17px;
              width: 300px;
              display: block;
              height: 38px;
              resize: none;
              overflow: hidden;
              border-radius: 10px;
            "
            ref="searchProduct"
            v-on:keyup.enter="getProduct(barcode2)"
            v-model="barcode2"
            id="Barcode2"
            name="Barcode2"
            placeholder="Enter Product Barcode"
            @keydown.enter.prevent="handleEnter"
          ></textarea>

          <!--Set order parked -->

          <button
            class="add"
            v-if="hasPermission(4)"
            @click="processOrder('1')"
          >
            {{ this.jsonData.btn_park_order }}
          </button>

          <!--Set order request discount -->

          <!-- <button class="add" v-if="hasPermission(3)" @click="processOrder('2')">{{ this.jsonData.btn_request_discount

            }}</button> -->

          <!-- <button class="add" v-if="hasPermission(2)" @click="processOrder('3')">Delivery</button> -->

          <label class="h1" style="color: white">{{
            this.currentOrderId
          }}</label>

          <div v-show="showError" style="text-align: center">
            <label class="h3" style="color: cyan">
              {{ this.mainErrorMsg }}
            </label>
          </div>
        </div>
      </div>

      <div v-if="toggle">
        <div
          class="row table-wrap"
          style="
            color: #fff;
            padding-right: 15px;
            padding-left: 15px;
            padding-bottom: 0px;
            padding-top: 10px;
            background-color: var(--theme-bg-end);
            margin-top: 0px;
            margin-left: 5px;
            margin-right: 5px;
          "
        >
          <table
            class="table"
            style="color: #fff; margin-top: 0px; margin-bottom: 0px"
          >
            <tr>
              <td>
                <div class="grid-container-element" style="font-size: 21px">
                  <div
                    class="grid-child-element purple"
                    style="text-align: right"
                  >
                    {{ this.item_name }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right"
                  >
                    {{ this.qty }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right"
                  >
                    {{ this.unit_price }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right"
                  >
                    {{ this.item_price }}
                  </div>

                  <div class="grid-child-element green"></div>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div
          class="row table-wrap"
          style="
            color: #fff;
            padding: 15px;
            padding-top: 0px;
            height: 300px;
            background-color: var(--theme-bg-end);
            margin-top: 0px;
            margin-left: 5px;
            margin-right: 5px;
          "
        >
          <table
            class="table"
            style="color: #fff; margin-top: 0px; padding-top: 0px"
          >
            <tr v-for="item in currentItem" :key="item.seqId">
              <td>
                <div
                  class="grid-container-element"
                  style="
                    padding-bottom: 4px;
                    padding-top: 4px;
                    vertical-align: middle;
                  "
                >
                  <div
                    class="grid-child-element purple"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ item.item_name }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    <input
                      typ="text"
                      style="width: 50px; color: #000; font-size: 19px"
                      v-on:keyup.enter="changCurrentItemQty()"
                      @blur="changCurrentItemQty()"
                      v-show="!setQty"
                      id="currentItemQty"
                      ref="currentItemQty"
                      v-model="currentItemQty"
                    />

                    <!--<a href="#" @click="changCurrentItemQty()" v-show="!setQty" style="color:green"><span class="glyphicon glyphicon-ok" style="padding:5px;color:green"></span></a>-->

                    <div v-show="setQty" style="font-size: 19px">
                      {{ parseFloat(item.qty).toFixed(3) }}
                    </div>
                  </div>

                  <!--<div class="grid-child-element green" style="text-align:right;font-size: 19px;">{{(formatNumber(item.standard_rate)).toFixed(2)}}</div>-->

                  <div
                    v-if="!hasPermission(66)"
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ formatNumber(Math.floor(item.standard_rate)) }}
                  </div>

                  <div
                    v-else
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    <input
                      typ="text"
                      style="width: 50%; color: #000; font-size: 19px"
                      v-on:keyup.enter="updateCurrentItemPrice()"
                      @blur="updateCurrentItemPrice()"
                      v-if="showSetPrice && currentChangingPrice == item.seqId"
                      id="currentItemPricing"
                      ref="currentItemPricing"
                      v-model="currentItemPricing"
                    />

                    <div
                      v-if="!showSetPrice || currentChangingPrice != item.seqId"
                      style="font-size: 19px"
                    >
                      {{ formatNumber(Math.floor(item.standard_rate)) }}
                    </div>
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ formatNumber(Math.floor(item.price)) }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    <a
                      href="#"
                      @click="deleteOrderItem(item.seqId)"
                      style="color: red"
                      ><span class="glyphicon"
                        ><i
                          class="fa-solid fa-trash-can"
                          style="font-size: x-large"
                        ></i></span
                    ></a>

                    <a
                      v-if="hasPermission(66)"
                      href="#"
                      @click="setChangePrice(item.seqId)"
                      style="color: green; margin-left: 1.5rem"
                      ><span class="glyphicon"
                        ><i
                          class="fa-solid fa-pencil"
                          style="font-size: x-large"
                        ></i></span
                    ></a>
                  </div>
                </div>
              </td>
            </tr>

            <tr v-for="item in orderItems" :key="item.seqId">
              <td>
                <div
                  class="grid-container-element"
                  style="padding-bottom: 4px; padding-top: 4px"
                >
                  <div
                    class="grid-child-element purple"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ item.item_name }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ parseFloat(item.qty).toFixed(3) }}
                  </div>

                  <!--<div class="grid-child-element green" style="text-align:right;font-size: 19px;">{{(formatNumber(Math.floor(item.standard_rate)))}}</div>-->

                  <div
                    v-if="!hasPermission(66)"
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ formatNumber(Math.floor(item.standard_rate)) }}
                  </div>

                  <div
                    v-else
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    <input
                      typ="text"
                      style="width: 50%; color: #000; font-size: 19px"
                      v-on:keyup.enter="updateOrderItemPrice(item.seqId)"
                      @blur="updateOrderItemPrice(item.seqId)"
                      v-if="showSetPrice && currentChangingPrice == item.seqId"
                      id="currentItemPricing"
                      ref="currentItemPricing"
                      v-model="currentItemPricing"
                    />

                    <div
                      v-if="!showSetPrice || currentChangingPrice != item.seqId"
                      style="font-size: 19px"
                    >
                      {{ formatNumber(Math.floor(item.standard_rate)) }}
                    </div>
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    {{ formatNumber(Math.floor(item.price)) }}
                  </div>

                  <div
                    class="grid-child-element green"
                    style="text-align: right; font-size: 19px"
                  >
                    <a
                      href="#"
                      @click="deleteOrderItem(item.seqId)"
                      style="color: red"
                      ><span class="glyphicon"
                        ><i
                          class="fa-solid fa-trash-can"
                          style="font-size: x-large"
                        ></i></span
                    ></a>

                    <a
                      v-if="hasPermission(66)"
                      href="#"
                      @click="setOrderChangePrice(item.seqId)"
                      style="color: green; margin-left: 1.5rem"
                      ><span class="glyphicon"
                        ><i
                          class="fa-solid fa-pencil"
                          style="font-size: x-large"
                        ></i></span
                    ></a>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div v-if="showParked" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; background:var(--form-color); display: flex; justify-content: center;">
        <div
          style="
            display: flex;
            justify-content: center;
            width: 100%;
          "
        >
          <div
            style="
              width: 90%;
              margin-top: 100px;
              background: #1a1f2e;
              border-radius: 18px;
              overflow-y: auto;
              display: block;
              height: fit-content;
              overflow-y: auto !important;
              overflow-x: auto !important;
              border-radius: 10px;
              /* background-color: rgba(0, 0, 0, 0.2); */
               background:var(--form-color);
              scrollbar-width: thin;
              scrollbar-color: var(--theme-primary) var(--theme-scrollbar-track);
              "
            >
           

            <div v-if="isParkedLoading" class="parked-loading">
              <div class="parked-spinner"></div>
              <div style="font-size: 18px; color: #fff;"></div>
            </div>

            <table v-else-if="parked && parked.length > 0" class="table" style="color: #fff; margin-bottom: 0;">
              <thead>
                <tr>
                  <th style="font-size:18px; text-align:right;">Grand Amount</th>
                  <th style="font-size:18px; text-align:center;">Number of items</th>
                  <th style="font-size:18px; text-align:center;">Order Date</th>
                  <th style="font-size:18px; text-align:center;">Order Time</th>
                  <th style="font-size:18px;">{{ this.jsonData.order_no }}</th>
                  <th style="font-size:18px;"></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in parked" :key="item.item_code">
                  <td style="font-size:18px; text-align:right;">
                    {{ formatNumber(item.orderAmount) }}
                  </td>

                  <td style="font-size:18px; text-align:center;">
                    {{ item.numberOfItems }}
                  </td>

                  <td style="font-size:18px; text-align:center;">
                    {{ item.orderDate }}
                  </td>

                  <td style="font-size:18px; text-align:center;">
                    {{ item.orderTime }}
                  </td>

                  <td>
                    <button
                      class="btn btn-success"
                      @click="showParkedOrders(item.orderId)"
                    >
                      {{ item.orderId }}
                    </button>
                  </td>

                  <td>
                    <button
                      v-if="hasPermission(16)"
                      class="btn btn-danger"
                      @click="deleteOrder(item.orderId)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              v-else
              style="
                padding: 30px 15px;
                text-align: center;
                font-size: 18px;
                color: #fff;
              "
            >
             There are no parked orders
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="padding: 15px; margin-top: 10px">
        <div
          class="col-sm-4"
          style="
            width: 100%;
            color: #000000;
            background-color: var(--theme-bg-end);
            min-height: 210px;
          "
        >
          <div
            class="col-sm-4"
            style="
              position: fixed;
              width: 25px;
              height: 30px;
              min-height: 20px;
              left: 0px;
              bottom: 230px;
              margin-top: 0px;
              margin-bottom: 0px;
              margin-left: 0px;
              color: #000000;
              background-color: var(--theme-bg-end);
              margin-left: -15px;
              margin-right: -10px;
            "
          >
            <a
              href="#"
              v-show="!setQty"
              @click="changCurrentItemQty()"
              style="color: green"
              ><span
                class="glyphicon glyphicon-ok"
                style="padding-bottom: 20px; margin-left: 80px"
              ></span
            ></a>
          </div>

          <div
            class="col-sm-4"
            style="
              position: fixed;
              width: 250px;
              height: 300px;
              min-height: 200px;
              left: 0px;
              bottom: -80px;
              margin-top: 0px;
              margin-bottom: 0px;
              margin-left: 0px;
              color: #000000;
              background-color: var(--theme-bg-end);
              margin-left: -15px;
              margin-right: -10px;
            "
          >
            <numericpad
              :onInput="onInput"
              :onDelete="onDelete"
              :onReset="onReset"
              :show="showKeypad"
            />
          </div>
        </div>

        <div
          class="col-sm-4"
          style="
            color: #ffffff;
            position: fixed;
            left: 225px;
            bottom: 40px;
            margin-bottom: -50px;
            margin-left: 0px;
            width: 205px;
            height: 230px;
          "
        >
          <div
            class="row"
            style="
              background-color: var(--color4);
              margin-bottom: 0px;
              border-style: outset;
              height: 210px;
              border-radius: 10px;
            "
          >
            <!-- <p style="font-size: 16px; font-weight: 700; text-align: center; color: #000000;margin: 0px 0px;">{{this.jsonData.payment_method}}</p> -->

            <div
              class="row"
              style="margin: 0px; padding: 0.2rem 0px; width: 200px"
            >
              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.gift_card }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.balance || 0) }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="margin: 0px; padding: 0.2rem 0px; width: 200px"
            >
              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.cash }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.cashAmount || 0) }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="margin: 0px; padding: 0.2rem 0px; width: 200px"
            >
              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.credit }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.creditAmount || 0) }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="margin: 0px; padding: 0.2rem 0px; width: 200px"
            >
              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.mobile_btn }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.mobileAmount || 0) }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="margin: 0px; padding: 0.2rem 0px; width: 200px"
            >
              <!--<div class="col-sm-6" style="text-align: left; color: #000000;"> <p style="font-size: 14px; font-weight: 700; padding-left: 15px;">Account:</p></div>-->

              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.account }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.accountAmount || 0) }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="
                margin: 0px;
                padding: 0.2rem 0px;
                width: 200px;
              "
            >
              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.paid }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.paidAmount || 0) }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="margin: 0px; padding: 0px; width: 200px"
            >
              <div
                class="col-sm-6"
                style="
                  text-align: left;
                  color: #000000;
                  margin: 0px 0px;
                  padding: 0px 0px;
                "
              >
                <p
                  style="
                    font-weight: 700;
                    padding-left: 5px;
                    color: black;
                    font-size: 1em;
                  "
                >
                  {{ this.jsonData.outstanding }}:
                </p>
              </div>

              <div
                class="col-sm-6"
                style="text-align: right; color: #000000; margin: 0px 0px"
              >
                <p style="font-weight: 700; color: black; font-size: 0.85em">
                  {{ formatNumber(this.notPaidAmount || 0) }}
                </p>
              </div>
            </div>

            <div
              class="col-sm-4"
              style="
                color: #ffffff;
                position: fixed;
                left: 640px;
                bottom: 16px;
                margin-bottom: 0px;
                margin-left: 0px;
                width: 250px;
                height: 210px;
              "
            >
              <div
                v-show="showloyality"
                style="
                  background-color: #cccccc;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  border-top: 1px solid #cccccc;
                  border-right: 1px solid #333333;
                  border-bottom: 1px solid #333333;
                  border-left: 1px solid #cccccc;
                  padding-left: 10px;
                  border-radius: 10px;
                "
              >
                <h2
                  style="
                    font-size: 16px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    text-align: center;
                  "
                >
                  {{ this.jsonData.loyalty_customer_info }}
                </h2>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  Customer_tin: {{ this.customer_tin }}
                </h3>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  {{ this.jsonData.loyalty_name }}: {{ this.name }}
                </h3>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  {{ this.jsonData.loyalty_gender }}: {{ this.gender }}
                </h3>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  {{ this.jsonData.loyalty_email }}: {{ this.email }}
                </h3>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  {{ this.jsonData.loyalty_phone }}: {{ this.phone }}
                </h3>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  {{ this.jsonData.loyalty_total_points }}:
                  {{ this.customerBalance }}
                </h3>

                <h3
                  style="
                    font-size: 14px;
                    color: navy;
                    font-weight: bold;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  {{ "Points" }}: {{ this.totalpoints }}
                </h3>
              </div>

              <!--          <div v-show="giftCardInfos" style="background-color: #FFFFFF;margin-top:10px;margin-bottom:10px;border-top: 1px solid #CCCCCC; border-right: 1px solid #333333; border-bottom: 1px solid #333333; border-left: 1px solid #CCCCCC;padding-top:5px;padding-left:10px">

             <h2 style="font-size: 16px; font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_info}}:</h2>

             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_number}}: {{this.giftcardnumber}}</h3>

             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_name}}: {{this.giftcardname}}</h3>

             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_balance}}: {{this.balance}}</h3>

           </div>

            --></div>
          </div>
        </div>

        <div
          class="col-sm-4"
          style="
            padding-top: 3px;
            background-color: var(--theme-bg-end);
            color: #ffffff;
            position: fixed;
            left: 440px;
            bottom: -7px;
            margin-left: 0px;
            width: 210px;
            height: 230px;
            font-size: 1.5em;
            
          "
        >
          <div
            class="row"
            style="margin-bottom: 40px; border-style: outset; height: 210px;border-radius: 10px;"
          >
            <div
              class="row"
              style="margin: 0px; width: 210px; padding-top: 0px;"
            >
              <div class="col-sm-9" style="text-align: left; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  <b>Items# :</b>
                </p>
              </div>

              <div class="col-sm-3" style="text-align: right; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ this.orderItems.length + this.currentItem.length }}
                </p>
              </div>
            </div>

            <div
              class="row"
              style="margin: 0px; width: 210px; padding-top: 10px"
            >
              <div class="col-sm-6" style="text-align: left; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ this.jsonData.net_total }}:
                </p>
              </div>

              <div class="col-sm-6" style="text-align: right; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ formatNumber(this.netTotalAmount) }}
                </p>
              </div>
            </div>

            <div class="row" style="margin: 0px; padding: 0px; width: 210px">
              <div class="col-sm-6" style="text-align: left; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  Vat:
                </p>
              </div>

              <div class="col-sm-6" style="text-align: right; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ formatNumber(this.vatAmount) }}
                </p>
              </div>
            </div>

            <div class="row" style="margin: 0px; padding: 0px; width: 210px">
              <div class="col-sm-6" style="text-align: left; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ this.jsonData.discount }}:
                </p>
              </div>

              <div class="col-sm-6" style="text-align: right; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ formatNumber(this.discountAmount) }}
                </p>
              </div>
            </div>

            <!-- <div class="row" style="margin: 0px; padding: 0px;width:210px">

              <div class="col-sm-6" style="text-align: left; color: #ffffff;">

                <p style=" font-weight: 300;  color:white; font-size:0.86em">Diff:</p>

              </div>

              <div class="col-sm-6" style="text-align: right; color: #ffffff;">

                <p style=" font-weight: 300; color:white; font-size:0.86em">{{ (formatNumber(this.diffAmount)) }}</p>

              </div>

            </div> -->

            <div class="row" style="margin: 0px; padding: 0px; width: 210px">
              <div class="col-sm-6" style="text-align: left; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.866em">
                  G.T
                </p>
              </div>

              <div class="col-sm-6" style="text-align: right; color: #ffffff">
                <p style="font-weight: 300; color: white; font-size: 0.86em">
                  {{ formatNumber(this.grandTotalAmount) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="split20 right" style="padding-top: 80px">
        <div class="grid-container" style="row-gap: 0px">
          <button
            v-if="hasPermission(5)"
            @click="handleSetQty"
            class="grid-item button"
            style="background-color: var(--color1); color: #fff"
          >
            <span>🔢</span> {{ this.jsonData.set_qunt_btn }}
          </button>

          <button
            v-if="hasPermission(6)"
            @click="handleCheckPrice"
            class="grid-item button"
            style="background-color: var(--color2); color: #fff"
          >
            <span>🔍</span> {{ this.jsonData.chk_price_btn }}
          </button>

          <button
            v-if="hasPermission(7)"
            @click="isLoyalityOpen = true"
            class="grid-item button"
            style="background-color: var(--color3); color: #fff"
          >
            <span>👤</span> {{ this.jsonData.loyalty_card_btn }}
          </button>

          <button
            v-if="hasPermission(8) && allowSync"
            @click="syncProducts()"
            class="grid-item button"
            style="background-color: #317185; color: #fff"
          >
            <span>🔄</span> Sync Products
          </button>

          <button
            v-if="hasPermission(9)"
            @click="clearPayments"
            class="grid-item button"
            style="background-color:#d6100e; color: #fff; padding: 0"
          >
            <span>🧹</span> {{ this.jsonData.clear_payments_btn }}
          </button>

          <button
            v-if="hasPermission(10)"
            @click="handleGiftCard"
            class="grid-item button"
            style="background-color: #6E79B6; color: #fff"
          >
            <span>🎁</span> {{ this.jsonData.gift_card_btn }}
          </button>

          <button
            v-if="hasPermission(11)"
            @click="handlePayCash"
            class="grid-item button"
            style="background-color: #594175; color: #fff"
          >
            <span>💵</span> {{ this.jsonData.cash_btn }}
          </button>

          <button
            v-if="hasPermission(12)"
            @click="handlePayCredit"
            class="grid-item button"
            style="background-color: var(--color4); color: #fff"
          >
            <span>💳</span> {{ this.jsonData.card_btn }}
          </button>

          <button
            v-if="hasPermission(46)"
            @click="handlePayMobile"
            class="grid-item button"
            style="background-color:#d48bb3; color: #fff"
          >
            <span>📱</span> {{ this.jsonData.mobile_btn }}
          </button>

          <button
            v-if="hasPermission(13) && this.currentcreditstatus == 1"
            @click="handlePayAccount"
            class="grid-item button"
            style="background-color: var(--theme-accent); color: #fff"
          >
            <span>🧾</span> {{ this.jsonData.acc_btn }}
          </button>
        </div>
      </div>
    </div>

    <Loiality
      :open="isLoyalityOpen"
      :loyality="this.loyality"
      @getLoialityPoints="setLoialityPoints($event)"
      @close="isLoyalityOpen = !isLoyalityOpen"
    />

    <GiftCard
      :open="isGiftCardOpen"
      @getGiftCardInfos="setGiftCardInfos($event)"
      @close="isGiftCardOpen = !isGiftCardOpen"
    />

    <Void
      :open="isVoidOpen"
      @getVoidPermission="setVoidPermission($event)"
      @close="isVoidOpen = !isVoidOpen"
    />

    <DeleteOrderPerm
      :open="isVoidOrderOpen"
      @getDeleteOrderPermission="setDeleteOrderPermission($event)"
      @getDeleteUser="setDeleteUser($event)"
      @close="isVoidOrderOpen = !isVoidOrderOpen"
    />

    <CheckPrice
      :open="isCheckPriceOpen"
      :products="this.products"
      :msgItems="msgItems"
      @close="isCheckPriceOpen = !isCheckPriceOpen"
    />

    <NewProduct
      :open="isNewProductOpen"
      :products="this.products"
      :msgItems="msgItems"
      @getNewProductData="setNewProductData($event)"
      @close="isNewProductOpen = !isNewProductOpen"
    />

    <PayCash
      :cashAmount="parseFloat(notPaidAmount).toFixed(2)"
      :pay_cash_close="pay_cash_close"
      :pay_cash_add_payment="pay_cash_add_payment"
      :pay_cash_cash_amount="pay_cash_cash_amount"
      :pay_cash_title="pay_cash_title"
      :open="isPayCashOpen"
      @getCashAmount="setCashAmount($event)"
      @close="isPayCashOpen = !isPayCashOpen"
    />

    <PayCredit
      :creditAmount="parseFloat(notPaidAmount).toFixed(2)"
      :open="isPayCreditOpen"
      @getCreditAmount="setCreditAmount($event)"
      @close="isPayCreditOpen = !isPayCreditOpen"
    />

    <PayMobile
      :mobileAmount="parseFloat(notPaidAmount).toFixed(2)"
      :open="isPayMobileOpen"
      @getMobileAmount="setMobileAmount($event)"
      @close="isPayMobileOpen = !isPayMobileOpen"
    />

    <PayAccount
      :customer_id="customerId"
      :accountAmount="parseFloat(notPaidAmount).toFixed(2)"
      :open="isPayAccountOpen"
      @getCustomernumber="setCustomernumber($event)"
      @getCustomer="setCustomer($event)"
      @getCustomerName="setCustomerName($event)"
      @getAccountAmount="setAccountAmount($event)"
      @close="isPayAccountOpen = !isPayAccountOpen"
    />

    <!--<CloseCash :open="isCloseCashOpen" @close="isCloseCashOpen = !isCloseCashOpen" @setCashDetail="closeUserCash($event)"/>-->

    <CloseCash
      :open="isCloseCashOpen"
      :paymentData="paymentData"
      @close="isCloseCashOpen = !isCloseCashOpen"
      @setCashDetail="closeUserCash($event)"
      ref="CloseCashref"
    />

    <ChangePassword
      :open="isChangePasswordOpen"
      @close="isChangePasswordOpen = !isChangePasswordOpen"
    />

    <ShowInfos
      :open="isShowInfosOpen"
      :popupMessage="popupMessage"
      :msgItems="msgItems"
      @close="isShowInfosOpen = !isShowInfosOpen"
    />
  </div>
  </div>
</template>

<script>
//import ProductList from "@/components/ProductList";


import Loiality from "@/components/Loiality";

import AppHeader from "@/components/AppHeader.vue";

import GiftCard from "@/components/GiftCard";

import Void from "@/components/Void";

import CheckPrice from "@/components/CheckPrice";

import NewProduct from "@/components/NewProduct";

import PayCash from "@/components/PayCash";

import PayCredit from "@/components/PayCredit";

import PayMobile from "@/components/PayMobile";

import PayAccount from "@/components/PayAccount";

import CloseCash from "@/components/CloseCash";

import ShowInfos from "@/components/ShowInfos";

import VueBarcode from "@chenfengyuan/vue-barcode";

import QrcodeVue from "qrcode.vue";

import ChangePassword from "@/components/ChangePassword";

//import SimpleKeyboard from "@/components/SimpleKeyboard";

import numericpad from "@/components/SimpleKeyboard";

//import { useRoute } from 'vue-router'

import { ref } from "vue";

import axios from "axios";

import commonServices from "@/shared/commonServices";

import efris from "@/shared/efris";

import router from "@/router";

import { mapGetters } from "vuex";

import DeleteOrderPerm from "@/components/DeleteOrderPerm.vue";


const Swal = require("sweetalert2");

export default {
  computed: {
    ...mapGetters({
      posData: "posData",

      modules: "modules_options/modulesPers",

      userPermissions: "modules_options/userPermissions",
    }),
  },

  mixins: [commonServices, efris],

  mounted() {
    this.$refs.searchProduct.value = "";
    this.barcode2 = "";
    this.getActivePromotions();

    if (localStorage.return_ok === "1") {
      this.return_ok = true;
    }

    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }

    this.barcode = "";

    this.getTaxAmount();

    if (localStorage.userId === undefined) {
      this.$router.push({ name: "login" });
    }

    this.allowSync = localStorage.getItem('allow_sync') == 1;

    this.language = "ar";

    this.handleLanguage();

    this.$el.querySelector("#Barcode2").focus = true;

    this.getHeaderFooter();

    this.getLogo();

    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';

    const action = this.$route.query.action;
    if (action === "parked") {
      this.getShowParked();
    } else if (action === "change_password") {
      this.getParked();
      this.isChangePasswordOpen = true;
    } else {
      this.getParked();
    }
  },

  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute(
        "style",
        'font-family: "Catamaran", sans-serif;background-color: var(--theme-bg-end)'
      );
  },

  components: {
    AppHeader,
    QrcodeVue,
    VueBarcode,
    Loiality,
    GiftCard,
    Void,
    CheckPrice,
    PayCash,
    PayCredit,
    PayMobile,
    numericpad,
    PayAccount,
    CloseCash,
    ShowInfos,
    NewProduct,
    ChangePassword,
    DeleteOrderPerm,
  },

  data: function () {
    return {
      efrisData: {
        ura_invoice_id: "fiwkfiwjefijwiejf",

        ura_invoice_no: "wokefkewofkwoekfowkefokweok",

        ura_verification_code: "f93092kweoofwkefwefw9ef",

        ura_qr_code: "wofekw9ef9wefkwofew9ef9ei",
      },

      invoiceDiscount: 0,

      promoDiscountAmount: 0,

      currentPromotions: [],

      reports_ok: false,

      return_ok: false,

      popupMessage: "",

      driverOrderId: "",

      msgItems: [],

      driverItems: [],

      drivers: [],

      barcode2: "",

      currencyValues: [],

      paymentData: [],

      allowSync: false,

      showError: false,

      logoImage: "",

      mainErrorMsg: "",

      customerId: 0,

      accCustomerid: 0,

      logoUrl: "",

      changeAmount: 0,

      currentOrderId: "",

      isPrinted: false,

      isPaid: false,

      park_btn: true,

      orderParkStatus: "",

      printOk: true,

      currentOrderDirty: false,

      languageName: "",

      item_name: "",

      item_price: "",

      unit_price: "",

      emptyAmount: "",

      pay_cash_title: "",

      pay_cash_cash_amount: "",

      pay_cash_add_payment: "",

      pay_cash_close: "",

      qty: "",

      orderHeader: {},

      paymentMethod: {},

      number: "",

      maxLength: 20,

      showKeypad: true,

      jsonData: {},

      language: "en",

      filterdProducts: [],

      orderItems: [],

      promotions: [],

      currentItem: [],

      displayItems: [],

      barcode: "",

      seqId: 0,

      products: [],

      toggle: true,

      editedPrice: 0,

      editedRoderItem: [],

      authorizedToChangePrice: "",

      authorizedToDeleteOrder: "",

      totalOrderAmount: 0,

      grandTotalAmount: 0,

      netTotalAmount: 0,

      diffAmount: 0,

      vatAmount: 0,

      taxBaseAmount: 1.18,

      notPaidAmount: 0,

      currentcreditstatus: 0,

      outstandingAmount: "",

      discountAmount: 0,

      paidAmount: 0,

      giftCardAmount: 0,

      prcision: 0,

      ordeCompleted: "N",

      orderId: "",

      //title:'Loyality',

      lastinvoicenumber: "",

      loyality: null,

      giftCardInfos: null,

      cashAmount: 0,

      creditAmount: 0,

      mobileAmount: 0,

      paymentProvider: "",

      accountAmount: 0,

      customernumber: "",

      name: "",

      customer_tin: "",

      gender: "",

      email: "",

      phone: "",

      line1: "",

      line2: "",

      area: "",

      city: "",

      voideOrderId: 0,

      totalpoints: "",

      earnedpoints: 0,

      dis_percentage: 0,

      prompMinimum_total: 0,

      promoDiscount: 0,

      customersince: "",

      balance: 0,

      mobilePaymentProviderJson: {},

      customerBalance: 0,

      giftcardname: "",

      giftcardnumber: "",

      cashPop: false,

      setQty: true,

      setPrice: true,

      currentItemQty: "",

      currentItemPricing: "",

      showSetPrice: false,

      currentItemPrice: "",

      setQuantity: false,

      setCurrentPrice: false,

      parked: [],

      parkedSize: 0,

      showParked: false,

      isParkedLoading: false,

      showloyality: false,

      showChange: false,

      showDelivery: false,

      elem: "",

      customername: "",

      customer: 0,

      deleteItemIndex: -1,

      invoiceHeader: "",

      invoiceFooter: "",

      customer_tin: "",
    };
  },

  methods: {
    getActivePromotions: async function () {
      let activePromotionsJson = {};

      activePromotionsJson.appId = localStorage.appId;

      try {
        let dataURL = this.apiURL + "Promotion/getActivePromotions";

        let response = await axios.post(dataURL, activePromotionsJson);

        if (response.data.status === "success") {
          this.currentPromotions = response.data.results.promotions;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getHeaderFooter: async function () {
      try {
        let dataURL = this.apiURL + "Orders/getInvoiceHeader";

        let logoJson = { branchId: "1", langId: "15" };

        let response = await axios.post(dataURL, logoJson);

        if (response.data.status === "success") {
          this.invoiceHeader = response.data.results.header;

          this.invoiceFooter = response.data.results.footer;
        }
      } catch (error) {
        console.log(error);
      }
    },

    printElemm: function (elem) {
      var mywindow = window.open(
        "",
        "PRINT",
        "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none"
      );
      mywindow.document.write(
        '<html><head><title> Invoice </title><style>* {font-size: 12px;font-family: "Times New Romantd, th, tr, table { border-top: 1px solid black; border-collapse: collapse; } "; } td.description, th.description { width: 75px; max-width: 75px; } td.quantity, th.quantity { width: 40px; max-width: 40px; word-break: break-all; } td.price, th.price { width: 40px; max-width: 40px; word-break: break-all; } .centered { text-align: center; align-content: center; } .ticket { width: 155px; max-width: 155px; }</style>'
      );
      mywindow.document.write("</head><body>");
      mywindow.document.write(elem);
      mywindow.document.write("<br><br></body></html>");
      mywindow.print();
      mywindow.close();
      return true;
    },

    showParkedOrders: async function (id) {
      if (this.currentOrderDirty) {
        this.showError = true;

        this.mainErrorMsg = this.jsonData.complete_current_order;
      } else {
        try {
          this.showError = false;

          this.mainErrorMsg = "";

          let dataURL = this.apiURL + "Orders/getOrder";

          let orderJson = { appId: localStorage.appId, orderId: id };

          let response = await axios.post(dataURL, orderJson);

          if (response.data.status === "success") {
            let sequence = 0;

            let tempArr = [];

            let taxBase = 1;

            let taxBaseAmount = this.taxBaseAmount;

            response.data.results.items.forEach(function (item) {
              taxBase = 1;

              if (item.tax == "Standard") {
                taxBase = taxBaseAmount;
              }

              tempArr.push({
                seqId: sequence,

                barcode: item.barcode,

                item_code: item.item_code,

                item_name: item.item_name,

                item_group: item.item_group,

                taxRateName: item.tax,

                standard_rate: parseFloat(item.standard_rate).toFixed(2),

                price: parseFloat(item.price).toFixed(2),

                qty: item.qty,

                uom: item.uom,

                item_dis_price: item.qty.item_dis_price,

                tax: taxBase,

                item_discount: item.qty.item_discount,
              });

              sequence = sequence + 1;
            });

            this.orderItems = tempArr;

            this.orderItems.sort((a, b) => Number(b.seqId) - Number(a.seqId));

            this.currentOrderId = response.data.results.invoice;

            this.orderParkStatus = response.data.results.parkStatus;

            this.customer_name = response.data.results.customer_name;

            this.customerId = response.data.results.customerId;

            this.discountAmount = parseFloat(response.data.results.disValue);

            this.invoiceDiscount = parseFloat(response.data.results.disValue);

            //console.log("response.data.results.customerId", response.data.results.customerId)

            if (this.customerId != 0) {
              this.getCustomerById(this.customerId);
            }

            this.showParked = false;

            this.toggle = true;

            this.calcOrderTotalAmount();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    getCustomerById: async function (customerId) {
      try {
        if (customerId !== 0) {
          let dataURL = this.apiURL + "Loyalty/getCustomerById";

          let loialityJson = {
            appId: localStorage.appId,
            customerId: customerId,
          };

          let response = await axios.post(dataURL, loialityJson);

          this.loiality = response.data.results[0];

          this.customer_name = response.data.results[0].name;

          this.name = response.data.results[0].name;

          this.email = response.data.results[0].email;

          this.phone = response.data.results[0].phone;

          this.city = response.data.results[0].city;

          this.area = response.data.results[0].area;

          this.line1 = response.data.results[0].line1;

          this.line2 = response.data.results[0].line2;

          this.totalpoints = response.data.results[0].totalpoints;

          this.customerBalance = response.data.results[0].balance;

          this.giftCardInfos = null;

          this.showloyality = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getCustomerName: async function (customerId) {
      try {
        if (customerId !== 0) {
          let dataURL = this.apiURL + "Loyalty/getCustomerById";

          let loialityJson = {
            appId: localStorage.appId,
            customerId: customerId,
          };

          let response = await axios.post(dataURL, loialityJson);

          this.name = response.data.results[0].name;

          this.giftCardInfos = null;

          this.showloyality = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    deleteOrderItem(id) {
      this.deleteItemIndex = id;

      this.isVoidOpen = true;
    },

    setChangePrice(id) {
      this.currentChangingPrice = id;

      this.currentItem[0].standard_rate;

      this.currentItemPricing = this.currentItem[0].standard_rate;

      this.showSetPrice = true;
    },

    setOrderChangePrice(id) {
      this.currentChangingPrice = id;

      this.currentItemPricing = this.orderItems.find(
        (el) => el.seqId == id
      ).standard_rate;

      this.showSetPrice = true;
    },

    handleAddCustomer() {
      this.$router.push({ name: "customers" });
    },

    handleReturns() {
      this.$router.push({ name: "returns" });
    },

    getShowParked: async function () {
      await this.handleParked();
    },

    handleParked: async function () {
      this.showError = false;

      this.mainErrorMsg = "";

      this.clearOrderState();

      this.isParkedLoading = true;
      this.parked = [];
      this.parkedSize = 0;
      this.handleParkScreen();
      try {
        await this.getParked();
      } finally {
        this.isParkedLoading = false;
      }
    },

    handleParkScreen() {
        this.toggle = false;

        this.showParked = true;

        this.showDelivery = false;

        this.loyality = null;

        this.clearLoialityData();

        this.showDiscountRequested = false;
    },

    getParked: async function () {
      try {
        let dataURL = this.apiURL + "Orders/getOrderByStatus";

        let parkedJson = {
          appId: localStorage.appId,
          status: "1",
          userId: localStorage.userId,
        };

        let response = await axios.post(dataURL, parkedJson);

        if (response.data.status === "success") {
          if (response.data.results) this.parked = response.data.results;
          this.parkedSize = this.parked.length;
        }
      } catch (error) {
        console.log(error);
      }
    },

    closeParkedOverlay() {
      try {
        this.$router.replace({ name: "main" });
      } catch (e) {}
      this.handleMainPage();
    },

    getTaxAmount: async function () {
      try {
        let dataURL = this.apiURL + "Products/getTaxAmount";

        let response = await axios.post(dataURL, {});

        if (response.data.status === "success") {
          this.taxBaseAmount = parseFloat(response.data.tax);
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleMainPage() {
      this.showError = false;

      this.mainErrorMsg = "";

      this.clearOrderState();

      this.orderParkStatus = "";

      if (this.currentOrderDirty) {
      } else {
        this.orderItems = [];

        this.currentItem = [];
      }

      this.toggle = true;

      this.showParked = false;

      this.showDelivery = false;

      this.showDiscountRequested = false;
    },

    deleteOrder(id) {
      this.voideOrderId = id;

      this.isVoidOrderOpen = true;
    },

    setDeleteUser(user) {
      this.voidUserId = user;
    },

    setDeleteOrderPermission(authorizedToDeleteOrder) {
      if (this.voideOrderId !== 0) {
        this.authorizedToDeleteOrder = authorizedToDeleteOrder;

        if (this.authorizedToDeleteOrder === "Y") {
          this.voidParkOrder(this.voideOrderId);

          this.showSuccess("Done!");

          this.voideOrderId = 0;

          //const myTimeout = setTimeout("", 2000);

          //this.handleParked();

          this.getParked();
        } else {
          // Error message mo permission

          this.showAlert("You do ot have permission for this action!");
        }

        this.authorizedToDeleteOrder = "N";

        this.voideOrderId = 0;
      }
    },

    voidOrder: async function (id) {
      try {
        let dataURL = this.apiURL + "Orders/deleteOrder";

        let orderJson = {
          appId: localStorage.appId,
          orderId: id,
          deleted_by: this.voidUserId,
        };

        let response = await axios.post(dataURL, orderJson);

        if (response.data.status === "success") {
          this.orderDetails = [];

          this.orders = [];
        }
      } catch (error) {
        console.log(error);
      }
    },

    voidParkOrder: async function (id) {
      try {
        let dataURL = this.apiURL + "Orders/deleteOrder";

        let orderJson = {
          appId: localStorage.appId,
          orderId: id,
          deleted_by: this.voidUserId,
        };

        let response = await axios.post(dataURL, orderJson);

        if (response.data.status === "success") {
          this.orderDetails = [];

          this.orders = [];
        }
      } catch (error) {
        console.log(error);
      }
    },

    handlePayCash() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        this.isPayCashOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayCashOpen = true;
        } else {
          this.isPayCashOpen = false;

          this.showAlert(this.jsonData.no_order_to_pay);
        }
      }
    },

    handleChangePassword() {
      this.isChangePasswordOpen = true;
    },

    async handlePayCredit() {
      let cond = false;

      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);

        // this.isPayCreditOpen = true;

        cond = true;
      } else {
        if (this.customerId != 0) {
          // this.isPayCreditOpen = true;

          cond = true;
        } else {
          this.isPayCreditOpen = false;

          this.showAlert(this.jsonData.no_order_to_pay);
        }
        this.notPaidAmount = this.customerBalance;
      }

      if (cond) {
        if (!this.posData.pesapal_on || localStorage.getItem("ip") == "NO_IP") {
          this.isPayCreditOpen = true;

          return;
        }

        let alertPayment = this.showInfo("Please Pay Via PesaPal");

        let dataURL = `http://${localStorage.getItem("ip")}:5060`;

        let payJson = {
          txntype: "sale",

          timestamp: "2022-03-04T10:36:14+03:00",

          reference: "twst",

          paymentdetails: {
            currency: "UGX",

            amount: `${parseInt(this.notPaidAmount) * 100}`,

            taxamount: "0",
          },

          posdetails: {
            name: "MICROS",

            details: {
              cardpresent: "1",

              sequenceno: "000001",

              industrycode: "1",

              operator: "operator",

              lodgingcode: "3",

              siteid: "SITEID",
            },
          },
        };

        try {
          let response = await axios.post(dataURL, payJson);

          alertPayment.close();

          if (response.data.responsemsg == "APPROVAL") {
            this.setCreditAmount(this.notPaidAmount);
          } else {
            this.showAlert("Payment Failed Please Retry");
          }
        } catch (err) {
          alertPayment.close();

          this.showAlert("Pesapal Service Not Installed On This Machine");
        }
      }
    },

    handlePayMobile() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);

        this.isPayMobileOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayMobileOpen = true;
        } else {
          this.isPayMobileOpen = false;

          this.showAlert(this.jsonData.no_order_to_pay);
        }
        this.notPaidAmount = this.customerBalance;
      }
    },

    handlePayAccount() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);

        this.isPayAccountOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayAccountOpen = true;
        } else {
          this.isPayAccountOpen = false;

          this.showAlert(this.jsonData.no_order_to_pay);
        }
      }

    },

    handleSetQty() {
      if (this.currentItem.length === 0) {
        this.msgItems = [];

        this.msgItems.push({ id: "1", cont: this.jsonData.no_currentItem });

        //this.isShowInfosOpen = true;

        this.showAlert("There are no changable quantity in this order!");
      } else {
        let barcodeType = this.currentItem[0].newBacodeType;

        if (barcodeType === "99" || barcodeType === "97") {
          this.showAlert("You can not change current item quantity!");
        } else {
          this.$el.querySelector("#Barcode2").focus = false;

          // this.$el.querySelector('#currentItemQty').focus = true;

          this.setQty = false;

          this.setQuantity = true;

          this.currentItemQty = "";

          let e = document.createEvent("Event");

          e.initEvent("focus", true, true);

          this.$refs.currentItemQty[0].dispatchEvent(e);
        }
      }
    },

    changCurrentItemQty() {
      if (parseFloat(this.currentItemQty).toFixed(3) === 0) {
      } else {
        if (parseFloat(this.currentItemQty).toFixed(3) > 0) {
          this.currentItem[0].qty = parseFloat(this.currentItemQty);

          this.currentItem[0].price =
            parseFloat(this.currentItemQty) * this.currentItem[0].standard_rate;

          //this.currentItem[0].standard_rate = this.currentItem[0].standard_rate;

          this.currentItem[0].price_vat =
            parseFloat(this.currentItemQty) * this.currentItem[0].standard_rate;

          this.calcOrderTotalAmount();
        }
      }

      this.setQty = true;

      this.setQuantity = false;
    },

    updateCurrentItemPrice() {
      this.currentItem[0].standard_rate = this.currentItemPricing;

      this.currentItem[0].price =
        parseFloat(this.currentItem[0].qty) * this.currentItemPricing;

      this.showSetPrice = false;

      this.calcOrderTotalAmount();
    },

    updateOrderItemPrice(seqId) {
      let i = this.orderItems.findIndex((el) => el.seqId == seqId);

      this.orderItems[i].standard_rate = this.currentItemPricing;

      this.orderItems[i].price =
        parseFloat(this.orderItems[i].qty) * this.currentItemPricing;

      this.showSetPrice = false;

      this.calcOrderTotalAmount();
    },

    onInput(key) {
      if (key == 11) {
        if (this.setQuantity) {
          this.currentItemQty = (this.currentItemQty + "0").slice(
            0,
            this.maxLength
          );
        } else {
          this.barcode = (this.barcode + "0").slice(0, this.maxLength);
        }
      } else {
        if (this.setQuantity) {
          this.currentItemQty = (this.currentItemQty + key).slice(
            0,
            this.maxLength
          );
        } else {
          this.barcode = (this.barcode + key).slice(0, this.maxLength);
        }
      }

      //this.getProduct(this.barcode);
    },

    onDelete() {
      if (this.setCurrentPrice) {
        this.currentItemPrice = (this.currentItemPrice + key).slice(
          0,
          this.maxLength
        );
      } else {
        if (this.setQuantity) {
          this.currentItemQty = (this.currentItemQty + key).slice(
            0,
            this.maxLength
          );
        } else {
          this.barcode = this.barcode.slice(0, this.barcode.length - 1);
        }
      }
    },

    onReset() {
      if (this.setCurrentPrice) {
        this.currentItemPrice = "";
      } else {
        if (this.setQuantity) {
          this.currentItemQty = "";
        } else {
          this.barcode = "";
        }
      }
    },

    setVoidPermission(authorizedToChangePrice) {
      if (
        (this.orderItems.length !== 0 || this.currentItem.length !== 0) &&
        this.deleteItemIndex !== -1
      ) {
        this.authorizedToChangePrice = authorizedToChangePrice;

        let notfound = true;

        if (this.authorizedToChangePrice === "Y") {
          for (var i = 0; i < this.orderItems.length; i++) {
            if (this.orderItems[i].seqId === this.deleteItemIndex) {
              notfound = false;

              this.orderItems.splice(i, 1);

              this.currentOrderDirty = true;
            }
          }

          if (notfound) {
            if (this.currentItem.length > 0) {
              if (this.currentItem[0].seqId === this.deleteItemIndex) {
                this.currentItem = [];

                this.currentOrderDirty = true;
              }
            }
          }

          this.calcOrderTotalAmount();
        } else {
          // Error message mo permission
        }

        if (this.orderItems.length === 0 && this.currentItem.length === 0) {
          this.currentOrderDirty = false;
        }

        this.authorizedToChangePrice = "N";

        this.deleteItemIndex = -1;
      }
    },

    getpaymentnoncash: async function () {
      let userId = localStorage.userId;
      this.mobilePaymentProviderJson.userId = userId;
      try {
        let dataURL = this.apiURL + "Orders/get_payment_info";
        let response = await axios.post(
          dataURL,
          this.mobilePaymentProviderJson
        );
        if (response.data.status === "success") {
          this.paymentData = response.data.results;
          this.$refs.CloseCashref.getpaymentnoncash(this.paymentData);
        }
      } catch (error) {
        console.log(error);
      }
      return this.allMobilePaymentProviders;
    },

    handleCloseCash: async function () {
      this.getpaymentnoncash();

      this.isCloseCashOpen = true;
    },

    handleDailyTotals() {
      this.$router.push({ name: "dailytotal" });
    },

    handleItemsDaily() {
      this.$router.push({ name: "itemsdaily" });
    },

    handleReports() {
      this.$router.push({ name: "reports" });
    },

    handleSettings() {
      this.$router.push({ name: "settings" });
    },

    handleCheckPrice() {
      this.isCheckPriceOpen = true;

      this.msgItems = [];

      this.msgItems.push({
        id: "1",
        cont: this.jsonData.enter_barcode_or_name,
      });
    },

    handleGiftCard() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);

        this.isGiftCardOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isGiftCardOpen = true;
        } else {
          this.isGiftCardOpen = false;

          this.showAlert(this.jsonData.no_order_to_pay);
        }
      }
    },

    clearPayments: function () {
      this.cashAmount = 0;

      this.creditAmount = 0;

      this.mobileAmount = 0;

      this.accountAmount = 0;

      this.paidAmount = 0;

      this.balance = 0;

      this.discountAmount = 0;

      this.calcOrderTotalAmount();

      this.notPaidAmount =
        parseFloat(this.grandTotalAmount) -
        parseFloat(this.cashAmount) -
        parseFloat(this.creditAmount) -
        parseFloat(this.balance) -
        parseFloat(this.accountAmount) -
        parseFloat(this.discountAmount) -
        parseFloat(this.mobileAmount);

      this.outstandingAmount = this.notPaidAmount;
    },

    goLogin() {
      this.$router.push({ name: "login" });
    },

    handleFindInvoice() {
      let invoiceNumber = null;
      this.$router.push({ name: "find", params: { invoiceNumber } });
    },


    calcPaid() {
      this.paidAmount = 0;

      if (parseFloat(this.cashAmount) > 0) {
        this.paidAmount =
          parseFloat(this.paidAmount) + parseFloat(this.cashAmount);
      }

      if (parseFloat(this.creditAmount) > 0) {
        this.paidAmount =
          parseFloat(this.paidAmount) + parseFloat(this.creditAmount);
      }

      if (parseFloat(this.mobileAmount) > 0) {
        this.paidAmount =
          parseFloat(this.paidAmount) + parseFloat(this.mobileAmount);
      }

      if (parseFloat(this.balance) > 0) {
        this.paidAmount =
          parseFloat(this.paidAmount) + parseFloat(this.balance);
      }

      if (parseFloat(this.accountAmount) > 0) {
        this.paidAmount =
          parseFloat(this.paidAmount) + parseFloat(this.accountAmount);
      }

      this.notPaidAmount = parseFloat(this.grandTotalAmount - this.paidAmount);

    },

    async reCalcPayments() {
      this.paidAmount =
        parseFloat(this.cashAmount) +
        parseFloat(this.creditAmount) +
        parseFloat(this.accountAmount) +
        parseFloat(this.balance) +
        parseFloat(this.mobileAmount);

      this.notPaidAmount = parseFloat(this.grandTotalAmount - this.paidAmount);

      this.msgItems = [];

      this.msgItems.push({ id: "1", cont: this.jsonData.cahange });

      this.msgItems.push({
        id: "1",
        cont: -1 * parseFloat(this.notPaidAmount).toFixed(2),
      });

      let notPaid = this.notPaidAmount;

      this.outstandingAmount = Math.round(notPaid * 100) / 100;

      if (notPaid < 0) {
        notPaid = -1 * notPaid;
      }

      if (this.notPaidAmount < 0 && Math.round(notPaid * 100) / 100 !== 0) {
        this.isShowInfosOpen = true;
      }
      this.efrisData = {};


      if (this.posData.efris_on != "0") {
        try {
          await this.handleURA();
        } catch {}

        this.printUgandaOrder();
      } else {
        this.printUgandaOrder();
      }
    },

    async handleURA() {

      this.showInfo("Processing Invoice With URA");

      let uraJson = {
        username: localStorage.username,

        invoiceId: this.currentOrderId,
      };

      let dataURL = this.apiURL + "SendToEfris/syncSalesInvoice";

      let response = await axios.post(dataURL, uraJson);

      if (response.data.status === "success") {
        this.efrisData = response.data.itemsSuccessfullySynced;

        this.showSuccess("Synced To URA");
      } else {
        this.efrisData = { errorMsg: response.data.errorMsg };

        this.showAlert("Error Syncing With URA");
      }
    },

    getLogo: async function () {
      try {
        let dataURL = this.apiURL + "Orders/getInvoiceLogo";

        let logoJson = { appId: localStorage.appId };

        let response = await axios.post(dataURL, logoJson);

        if (response.data.status === "success") {
          this.logoUrl = response.data.results.logourl;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getCurrentDateTime() {
      let dateTimeStr = "";

      const nowDate = new Date();

      let year = nowDate.getFullYear();

      let month = nowDate.getMonth() + 1;

      let day = nowDate.getDate();

      var today = new Date();

      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      dateTimeStr = year + "-" + month + "-" + day + " " + time;

      return dateTimeStr;
    },

    startOrderProcessing(status) {
      this.processOrder("0");
    },

    printUgandaOrder() {
      this.isPrinted = false;

      let barcodeCanvas = document.querySelector(".vue_barcode_ref");

      let barcodeImageSrc = "";

      if (barcodeCanvas) {
        barcodeImageSrc = barcodeCanvas.toDataURL();
      }

      let qrcodeImageSrc = "";

      if (this.efrisData.ura_qr_code) {
        let qrcodeCanvas = document.querySelector(".vue_qrcode_ref");

        qrcodeImageSrc = qrcodeCanvas.toDataURL();
      }

      const nowDate = new Date();

      let year = nowDate.getFullYear();

      let month = nowDate.toLocaleString("en-us", { month: "short" });

      let day = nowDate.getDate();

      var today = new Date();

      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      let rows = ``;

      let self = this;

      let formatNumber = this.formatNumber;

      let quantity = 0;

      this.currentItem.forEach(function (order) {
        quantity += order.qty;

        rows += `<tr>

              <td colspan="5">${order.item_name}</td>

            </tr>

            <tr>

              <td style="text-align:center"></td>

              <td style="text-align:center">${parseFloat(order.qty).toFixed(
                3
              )}</td>

              <td style="text-align:center">${order.uom ?? "PCS"}</td>

              <td style="text-align:center">${formatNumber(
                order.standard_rate
              )}</td>

              <td style="text-align:center">${formatNumber(order.price)}</td>

            </tr>`;
      });

      this.orderItems.forEach(function (order) {
        quantity += order.qty;

        rows += `<tr>

              <td colspan="5">${order.item_name}</td>

            </tr>

            <tr>

              <td style="text-align:center"></td>

              <td style="text-align:center">${parseFloat(order.qty).toFixed(
                3
              )}</td>

              <td style="text-align:center">${order.uom ?? "PCS"}</td>

              <td style="text-align:center">${formatNumber(
                order.standard_rate
              )}</td>

              <td style="text-align:center">${formatNumber(order.price)}</td>

            </tr>`;
      });

      let payments = ``;

      let payTotal = 0;

      if (Math.round(parseFloat(this.discountAmount) * 100) / 100 > 0) {
        payTotal += this.discountAmount;

        payments += `<tr>

              <td colspan="4">Discount</td>

              <td style="text-align:center">${this.formatNumber(
                this.discountAmount
              )}</td>

            </tr>`;
      }

      if (Math.round(parseFloat(this.cashAmount) * 100) / 100 > 0) {
        payTotal += this.cashAmount;

        payments += `<tr>

              <td colspan="4">Cash</td>

              <td style="text-align:center">${this.formatNumber(
                this.cashAmount
              )}</td>

            </tr>`;
      }

      if (Math.round(parseFloat(this.creditAmount) * 100) / 100 > 0) {
        payTotal += parseFloat(this.creditAmount);

        payments += `<tr>

              <td colspan="4">Credit</td>

              <td style="text-align:center">${this.formatNumber(
                this.creditAmount
              )}</td>

            </tr>`;
      }

      if (Math.round(parseFloat(this.mobileAmount) * 100) / 100 > 0) {
        payTotal += parseFloat(this.mobileAmount);

        payments += `<tr>

              <td colspan="4">${this.paymentProvider}</td>

              <td style="text-align:center">${this.formatNumber(
                this.mobileAmount
              )}</td>

            </tr>`;
      }

      if (parseInt(this.accountAmount) < 0) {
        this.accountAmount = -1 * this.accountAmount;
      }

      if (Math.round(parseFloat(this.accountAmount) * 100) / 100 > 0) {
        payTotal += parseFloat(this.accountAmount);

        payments += `<tr>

              <td colspan="4">Account</td>

              <td style="text-align:center">${this.formatNumber(
                this.accountAmount
              )}</td>

            </tr>`;
      }

      if (this.balance > 0) {
        payments += `<tr>

              <td colspan="4">GiftCard ${this.giftcardnumber}</td>

              <td style="text-align:center">${this.formatNumber(
                this.balance
              )}</td>

            </tr>`;
      } else {
        if (this.balance !== 0) {
          `<tr>

              <td colspan="4">GiftCard ${this.giftcardnumber}</td>

              <td style="text-align:center">${this.formatNumber(
                this.balance
              )}</td>

            </tr>`;
        }
      }

      let changeTotal = payTotal - this.grandTotalAmount;

      if (changeTotal > 0) {
        changeTotal = `<tr>

              <td colspan="4">Change</td>

              <td style="text-align:center">${this.formatNumber(
                changeTotal
              )}</td>

            </tr>`;
      } else {
        changeTotal = ``;
      }

      let customerPoints = "";

      if (this.loyality != null && this.earnedpoints) {
        customerPoints += `

        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">

          <p>Points From This Sale:</p>

         <p> ${this.earnedpoints} </p>

        </div>

        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">

          <p>Total Points:</p>

         <p> ${parseInt(this.totalpoints) + parseInt(this.earnedpoints)} </p>

        </div>

        

        `;
      }

      let efrisPart = "";

      if (this.posData.efris_on != "0") {
        if (this.efrisData.ura_qr_code) {
          efrisPart = `

            <p>Fiscal Doc No:      ${this.efrisData.ura_invoice_no}  </p>

            <p>Verification Code:      ${this.efrisData.ura_verification_code}  </p>

            <img style="margin-bottom:4rem" width="60" src="${qrcodeImageSrc}"/>

          `;
        } else {
          efrisPart = this.efrisData.errorMsg
            ? `<p>Failed To Sync To URA: ${this.efrisData.errorMsg}</p>`
            : "<p>Failed To Sync To URA</p>";
        }
      }

      let elem = `

    ${this.invoiceHeader}

    <div style="display: flex; justify-content: center;flex-direction:column">

      

      

        <table>

          <thead>

            <th

              style="

                border-bottom: 1px dashed;

                padding: .5rem 0;

              "

              col="2"

            >

              Item

            </th>

            <th

              style="

                border-bottom: 1px dashed;

                padding: .5rem 0;

              "

            >

              Qty

            </th>

            <th

              style="

                border-bottom: 1px dashed;

                padding: .5rem 0;

              "

            >

              Unit

            </th>

            <th

              style="

                border-bottom: 1px dashed;

                padding: .5rem 0;

              "

            >

              Price

            </th>

            <th

              style="

                border-bottom: 1px dashed;

                padding: .5rem 0;

              "

            >

              Amount

            </th>

          </thead>

          <tbody>

            ${rows}

            <tr style="height: 15px;">

              <td colspan="5"></td>

            </tr>

            <tr>

              <td colspan="6" style="border-bottom: 1px dashed;text-align:center;font-weight: bolder;font-size: 1rem !important;padding-bottom: .8rem;">${
                this.orderItems.length + this.currentItem.length
              } Items Sold</td>

            </tr>

            <tr style="font-weight: 1000;">

              <td style="font-size: 1.1.rem !important;" colspan="4">Total</td>

              <td style="font-size: 1.1.rem !important;text-align:center">${this.formatNumber(
                this.grandTotalAmount
              )}</td>

            </tr>

            ${payments}

            <tr>

                <td style="border-bottom: 1px dashed; padding-bottom: .5rem" colspan="6"></td>

            </tr>

            <tr>

              <td style="padding-top:.5rem;" colspan="4">Tendered Total</td>

              <td style="padding-top:.5rem;text-align:center">${this.formatNumber(
                this.paidAmount
              )}</td>

            </tr>

            ${changeTotal}

            <tr>

              <td colspan="2" style="padding-top:.5rem;">VAT</td>

              <td style="padding-top:.5rem;">Amt W/o VAT</td>

              <td style="padding-top:.5rem;">VAT Amt</td>

              <td style="padding-top:.5rem;">Net Amt</td>

            </tr>

            <tr>

              <td colspan="2" style="padding-top:.5rem;">Standard</td>

              <td style="padding-top:.5rem;">${this.formatNumber(
                this.netTotalAmount
              )}</td>

              <td style="padding-top:.5rem;">${this.formatNumber(
                this.vatAmount
              )}</td>

              <td style="padding-top:.5rem;">${this.formatNumber(
                this.grandTotalAmount
              )}</td>

            </tr>

            <tr>

                <td style="border-bottom: 1px dashed; padding-bottom: .5rem" colspan="6"></td>

            </tr>

           

          </tbody>

        </table>

        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">

          <p>Customer Name:</p>

         <p> ${
           this.loyality != null || this.phone !== ""
             ? this.name
             : "Cash Customer"
         } </p>

        </div>



        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">

          <p>Customer TIN Number:</p>

         <p> ${
           this.loyality != null || this.phone !== "" ? this.customer_tin : "-"
         } </p>

        </div>

        

        ${customerPoints}

        <div style="display: flex; justify-content: center">

          <img style="width:65%"

            src="${barcodeImageSrc}"

          />

        </div>



        <table style="margin-bottom: 1rem;">

            <thead>

              <th

                style="padding: .5rem 0;"

                col="2"

              >

                Date

              </th>

              <th

                style="padding: .5rem 0;"

              >

                Time

              </th>

              <th

                style="padding: .5rem 0;"

              >

                Served By

              </th>

              

            </thead>

            <tbody>

              <tr>

                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${day} ${month} ${year}</td>

                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${time}</td>

                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${
                  localStorage.username
                }</td>

              </tr>



            

            </tbody>

          </table>

          ${efrisPart}

          ${this.invoiceFooter}

      `;

      var mywindow = window.open(
        "",
        "PRINT",
        "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none"
      );

      //mywindow.document.write('<img src="'+this.logoUrl+'" alt="Logo" width="100%"></img>');

      //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+'<img src='+this.logoUrl+' width="100%" alt="Logo">'+'</td></tr></table>';

      //mywindow.document.write('<h1>' + document.title  + '</h1>');

      //newEle = newEle + this.invoiceHeader+elem+this.invoiceFooter;

      //newEle = newEle + elem;

      mywindow.document.write(elem);

      //mywindow.document.close(); // necessary for IE >= 10

      //mywindow.focus(); // necessary for IE >= 10*/

      //const myTimeout = setTimeout("", 1000);

      setTimeout(function () {
        mywindow.print();
        mywindow.close();
      }, 300);

      this.isPrinted = true;

      return true;
    },

    closeUserCash: async function (cashDetail) {
      try {
        const nowDate = new Date();

        let dataURL = this.apiURL + "GiftCard/closeDailyShift1";

        let closeUserCashJson = {
          appId: "7",
          userId: localStorage.userId,
          orderDate: this.dateToYMD(nowDate),
        };

        let response = axios
          .post(dataURL, closeUserCashJson)
          .then((res) => {})
          .catch((error) => {
            console.log(error);
          });
        this.printCashDetail(cashDetail);

        // if (response.data.status === 'success') {

        // } else {

        //   this.printCashDetail(cashDetail);

        // }
      } catch (error) {
        console.log(error);
      }
    },

    printCashDetail(cashDetail) {
      let totalAmount = 0;
      let cashDetailVal = [];

      cashDetailVal = cashDetail;

      const nowDate = new Date();

      let year = nowDate.getFullYear();

      let month = nowDate.getMonth() + 1;

      let day = nowDate.getDate();

      var today = new Date();

      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      var cashier = localStorage.username;

      let viaInvStr = "";

      let totalCash = 0;

      viaInvStr = viaInvStr + "<p>FRAINE SUPERMARKET<br/>Cashier Closing</p>";

      viaInvStr =
        viaInvStr +
        "<tr><td> Date : " +
        day +
        "/" +
        month +
        "/" +
        year +
        " " +
        time +
        "<br></td></tr>";

      viaInvStr =
        viaInvStr + "<tr><td> Cashier : " + cashier + "<br></td></tr>";

      viaInvStr =
        viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';

      viaInvStr =
        viaInvStr + '<td colspan=3 align="center"><b>CURRENCY TYPES</b></td>';

      viaInvStr =
        viaInvStr + '<td width="33%" align="center"><b>COUNT</b></td>';

      viaInvStr =
        viaInvStr + '<td width="33%" align="center"><b>VALUE</b></td>';

      viaInvStr = viaInvStr + "</tr>";

      cashDetailVal.forEach(function (cashDetailItem) {
        viaInvStr =
          viaInvStr +
          '<tr><td colspan=3 align="left">' +
          cashDetailItem.value +
          '</td><td width="33%" align="center">' +
          cashDetailItem.count +
          '</td><td width="33%" align="center">' +
          cashDetailItem.value +
          "</td></tr>";

        // if (cashDetailItem.value === "Credit Card" || cashDetailItem.value === "Mobile") {

        //   totalCash = Math.round(totalCash * 100) / 100 + Math.round((cashDetailItem.count) * 100) / 100;

        // } else {

        //   totalCash = Math.round(totalCash * 100) / 100 + Math.round((cashDetailItem.value * cashDetailItem.count) * 100) / 100;

        // }
        // cashDetail.forEach(item => {
        if (!isNaN(cashDetailItem.value)) {
          // If the value is a number, multiply it by the count and add to totalAmount
          totalAmount +=
            parseInt(cashDetailItem.value) * parseInt(cashDetailItem.count);
        } else {
          // If the value is not a number, add the count to totalAmount
          totalAmount += parseInt(cashDetailItem.count);
        }
        //});
      });

      viaInvStr =
        viaInvStr +
        '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=2><b>TOTAL:</b></td><td width="50%" align="right" colspan=3><b>' +
        totalAmount +
        "</b></td></tr>";

      this.printElemm(viaInvStr);

      localStorage.clear();

      this.$router.push({ name: "login" });
    },

    setAccountAmount(accountAmount1) {
      let compartor = 0;

      let itemsCond = this.orderItems.length > 0 || this.currentItem.length > 0;

      this.accountAmount = accountAmount1;

      if (this.customerBalance != 0) {
        compartor = parseFloat(this.customerBalance.replace(",", ""));
      }

      let showError = false;

      this.calcPaid();

      if (itemsCond) {
        if (
          this.notPaidAmount < 0 ||
          Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 ===
            0
        ) {
          this.startOrderProcessing();
        } else {
          this.processPayment("-1");
        }
      } else {
        if (
          Math.round(this.accountAmount * 100) / 100 <=
          Math.round(compartor * 100) / 100
        ) {
          if (parseInt(this.accountAmount) > 0) {
            this.accountAmount = -1 * this.accountAmount;
          }

          this.processPayment("-1");
        } else {
          this.showAlert("You can not pay more than the remaining");

          this.isPayAccountOpen = true;
        }
      }
    },

    setCustomerName(customername) {
      this.customername = customername;
    },

    setCustomer(customer) {
      this.customer = parseInt(customer);
    },

    setCreditAmount(creditAmount) {
      if (
        Math.round(creditAmount * 100) / 100 <=
        Math.round(this.notPaidAmount * 100) / 100
      ) {
        this.creditAmount = parseFloat(creditAmount).toFixed(2);

        this.calcPaid();

        if (this.orderItems.length > 0 || this.currentItem.length > 0) {
          if (
            this.notPaidAmount < 0 ||
            Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) /
              100 ===
              0
          ) {
            this.startOrderProcessing();
          }
        } else {
          this.processPayment("-1");
        }
      } else {
        this.showAlert("You can not pay more than the remaining");

        this.isPayCreditOpen = true;
      }
    },

    setMobileAmount(mobileAmountObj) {
      let mobileAmount = mobileAmountObj.amount;

      this.paymentProvider = mobileAmountObj.provider;

      if (
        Math.round(mobileAmount * 100) / 100 <=
        Math.round(this.notPaidAmount * 100) / 100
      ) {
        this.mobileAmount = parseFloat(mobileAmount).toFixed(2);

        this.calcPaid();

        if (this.orderItems.length > 0 || this.currentItem.length > 0) {
          if (
            this.notPaidAmount < 0 ||
            Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) /
              100 ===
              0
          ) {
            this.startOrderProcessing();
          }
        } else {
          this.processPayment("-1");
        }
      } else {
        this.showAlert("You can not pay more than the remaining");

        this.isPayMobileOpen = true;
      }
    },

    setCashAmount(cashAmount) {
      this.cashAmount = parseFloat(cashAmount);

      this.calcPaid();

      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        if (
          this.notPaidAmount < 0 ||
          Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 ===
            0
        ) {
          this.startOrderProcessing();
        }
      } else {
        this.processPayment("-1");
      }
    },

    setNewProductData(newProductData) {
      this.products.push({
        item_name: newProductData.item_name,

        arabic_item_name: newProductData.item_name,

        item_group: "Not Found",

        barcode: newProductData.newproductbarcode,

        standard_rate: newProductData.newproductprice,

        item_code: newProductData.newproductbarcode,

        item_discount: newProductData.item_discount,
      });

      let newProduct = {};

      newProduct.item_name = newProductData.item_name;

      newProduct.arabic_item_name = newProductData.item_name;

      newProduct.item_group = "Not Found";

      newProduct.barcode = newProductData.newproductbarcode;

      newProduct.standard_rate = newProductData.newproductprice;

      newProduct.item_code = newProductData.newproductbarcode;

      newProduct.price = newProductData.price;

      newProduct.item_discount = newProductData.item_discount;

      //newProduct.standard_rate_vat = parseFloat(newProductData.newproductprice*1.05).toFixed(2);

      //newProduct.price_vat = parseFloat(newProductData.newproductprice*1.05).toFixed(2);

      if (this.products.length === 1) {
        this.addProductToOrder(newProduct);

        this.products = [];

        this.barcode = "";
      }
    },

    setGiftCardInfos(giftCardInfos) {
      this.loyality = null;

      this.giftCardInfos = giftCardInfos;

      if (this.giftCardInfos.status === "success") {
        this.customerId = this.giftCardInfos.results[0].customernumber;
      } else {
        this.showAlert("GiftCard Not Found");
      }

      if (this.giftCardInfos.results[0].balance <= 0) {
        this.showAlert("GiftCard's Balance Is 0");
      }

      this.giftcardnumber = this.giftCardInfos.results[0].giftcardnumber;

      this.giftcardname = this.giftCardInfos.results[0].giftcardname;

      // this.balance = this.giftCardInfos.results[0].balance;

      if (this.giftCardInfos.results[0].balance <= this.notPaidAmount) {
        this.balance = this.giftCardInfos.results[0].balance;
      } else {
        this.balance = this.notPaidAmount;
      }

      this.calcPaid();

      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        if (
          this.notPaidAmount < 0 ||
          Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 ===
            0
        ) {
          this.startOrderProcessing();
        }
      } else {
        this.processPayment("-1");
      }

      // } else {

      //   this.showAlert("You can not pay more than the remaining");

      // }
    },

    clearLoialityData() {
      this.loyality = null;

      this.showloyality = false;

      this.giftCardInfos = null;

      this.loyality = null;

      this.dis_percentage = 0;

      this.customernumber = "";

      this.name = "";

      this.gender = "";

      this.email = "";

      this.phone = "";

      this.customerId = 0;

      this.customer = 0;

      this.line1 = "";

      this.line2 = "";

      this.city = "";

      this.area = "";

      this.totalpoints = "";

      this.earnedpoints = 0;

      this.customersince = "";

      this.customerBalance = "";
    },

    setLoialityPoints(loyality) {
      this.currentcreditstatus = loyality.results[0].creditstatus;
      //console.log(loyality.results[0].creditstatus);

      if (loyality.status == "error") {
        this.showloyality = false;

        this.showAlert("Customer Not Found");

        return;
      }

      this.giftCardInfos = null;

      this.loyality = loyality;

      this.showloyality = true;

      this.dis_percentage = parseFloat(
        this.loyality.results[0].dis_percentage
      ).toFixed(2);

      this.customernumber = this.loyality.results[0].customernumber;

      this.name = this.loyality.results[0].name;

      this.gender = this.loyality.results[0].gender;

      this.email = this.loyality.results[0].email;

      this.phone = this.loyality.results[0].phone;

      this.customerId = this.loyality.results[0].id;

      //this.customer = this.loyality.results[0].id;

      //console.log("this.loyality.results[0]", this.loyality.results[0]);

      this.line1 = this.loyality.results[0].line1;

      this.line2 = this.loyality.results[0].line2;

      this.city = this.loyality.results[0].city;

      this.area = this.loyality.results[0].area;

      this.totalpoints = this.loyality.results[0].totalpoints;

      this.customerBalance = this.loyality.results[0].balance;

      this.customersince = this.loyality.results[0].customersince;

      this.customer_tin = this.loyality.results[0].customer_tin;
    },

    updateCustomerBalance: async function (account, amount) {
      try {
        let dataURL = this.apiURL + "Orders/updateCustomerBalance";

        let customerBalanceJson = {
          appId: "7",
          customerId: account,
          balance: amount,
        };

        let response = await axios.post(dataURL, customerBalanceJson);

        if (response.data.status === "success") {
        }
      } catch (error) {
        console.log(error);
      }
    },

    processPayment: async function (orderId) {
      try {
        this.isPaid = false;

        let cash = this.cashAmount;
        cash =
          parseFloat(this.grandTotalAmount).toFixed(2) -
          (Math.round(parseFloat(this.creditAmount).toFixed(2) * 100) / 100 +
            Math.round(parseFloat(this.accountAmount).toFixed(2) * 100) / 100 +
            Math.round(parseFloat(this.balance).toFixed(2) * 100) / 100 +
            Math.round(parseFloat(this.mobileAmount).toFixed(2) * 100) / 100);
        let accountid = 0;

        if (this.customer !== 0) {
          accountid = this.customer;

          this.getCustomerName(accountid);
        }

        let tempAcc = 0;

        if (this.grandTotalAmount === 0) {
          tempAcc = this.customerId;

          cash = parseFloat(this.cashAmount).toFixed(2);
        }

        const paymentDetails = [
          {
            paymenttype: "cash",
            amount: parseFloat(cash).toFixed(2),
            accountid: tempAcc,
          },

          {
            paymenttype: "credit",
            amount: parseFloat(this.creditAmount).toFixed(2),
            accountid: tempAcc,
          },

          {
            paymenttype: "mobile",
            amount: parseFloat(this.mobileAmount).toFixed(2),
            accountid: tempAcc,
            provider: this.paymentProvider,
          },

          {
            paymenttype: "account",
            amount: parseFloat(this.accountAmount).toFixed(2),
            accountid: accountid,
          },

          {
            paymenttype: "giftcard",
            cardnumber: this.giftcardnumber,
            amount: parseFloat(this.balance).toFixed(2),
            accountid: tempAcc,
          },
        ];

        let dataURL = this.apiURL + "Orders/payOrder";

        let paymentsJson = {
          customerId: this.customerId,
          appId: localStorage.appId,
          orderId: orderId,
          added_by: localStorage.userId,
          paymentDetails: paymentDetails,
        };

        let response = await axios.post(dataURL, paymentsJson);

        let totalAmount = 0;

        if (response.data.status === "success") {
          this.earnedpoints = response.data.earnedpoints;

          if (tempAcc !== 0) {
            let amount =
              -1 *
              parseFloat(
                this.cashAmount +
                  this.creditAmount +
                  this.balance +
                  this.mobileAmount
              ).toFixed(2);

            this.updateCustomerBalance(tempAcc, amount);
          }

          if (accountid !== 0) {
            this.updateCustomerBalance(
              accountid,
              parseFloat(this.accountAmount).toFixed(2)
            );
          }

          await this.reCalcPayments();

          if (this.isPrinted) {
            this.customer = 0;

            this.clearPayments();

            this.isPaid = true;

            this.currentOrderDirty = false;

            this.showChange = true;

            this.clearOrderState();
          }
        }

      } catch (error) {
        console.log(error);
      }
    },

    processOrder: async function (status) {
      //this.park_btn = false;

      this.totalPaymentAmount = this.grandTotalAmount;

      const nowDate = new Date();

      let orderDetailItems = [];

      let newOrderId = "";

      if (this.currentOrderId === "") {
        newOrderId = -1;
      } else {
        newOrderId = this.currentOrderId;
      }

      try {
        if (this.orderItems.length > 0) {
          this.orderItems.forEach(function (order) {
            orderDetailItems.push({
              barcode: order.barcode,
              item_group: order.item_group,
              item_code: order.item_code,
              item_name: order.item_name,
              qty: order.qty,
              standard_rate: parseFloat(order.standard_rate).toFixed(2),
              price: parseFloat(order.price).toFixed(2),
              item_discount: parseFloat(order.item_discount).toFixed(2),
            });
          });
        }

        if (this.currentItem.length > 0) {
          this.currentItem.forEach(function (order) {
            orderDetailItems.push({
              barcode: order.barcode,
              item_group: order.item_group,
              item_code: order.item_code,
              item_name: order.item_name,
              qty: order.qty,
              standard_rate: parseFloat(order.standard_rate).toFixed(2),
              price: parseFloat(order.price).toFixed(2),
              item_discount: parseFloat(order.item_discount).toFixed(2),
            });
          });
        }

        let orderDateTime = "2022-04-23 15:59:22";

        orderDateTime = this.getCurrentDateTime();

        this.orderHeader.appId = localStorage.appId;

        this.orderHeader.userId = localStorage.userId;

        this.orderHeader.username = localStorage.username;

        this.orderHeader.orderId = newOrderId;

        this.orderHeader.orderDate = orderDateTime;

        this.orderHeader.discount = this.discountAmount;

        this.orderHeader.totalamount = parseFloat(
          this.grandTotalAmount
        ).toFixed(2);

        this.orderHeader.customerId = this.customerId;

        this.orderHeader.status = status;

        //this.orderHeader.customerId = this.customernumber;

        this.orderHeader.customer_name = this.name;

        this.orderHeader.orderDetail = orderDetailItems;

        let orderJason = JSON.stringify(this.orderHeader);

        let itIsOk = true;

        if (status === "3" && this.name === "") {
          itIsOk = false;

          this.showAlert("Please select a customer");
        }

        if (status === "2" && this.discountAmount !== 0) {
          itIsOk = false;

          this.showError = true;

          this.mainErrorMsg = "This invoice alredy has a discount";
        }

        if (itIsOk) {
          let dataURL = this.apiURL + "Orders/createOrder";

          let response = await axios.post(dataURL, orderJason, {
            timeout: 20000,
          });

          if (response.data.status === "success") {
            if (this.customerId != 0) {
              //this.getCustomerById(this.customerId);
            }

            this.currentOrderId = response.data.invoice;

            if (status === "3") {
              //this.driverItems = this.drivers;

              this.driverOrderId = response.data.invoice;

              

            } else {
              if (status === "2") {
                this.discountRequestedSize = this.discountRequestedSize + 1;

                this.clearOrderState();
              } else {
                if (status === "1") {
                  this.parkedSize = this.parkedSize + 1;

                  this.clearOrderState();
                } else {
                  this.processPayment(this.currentOrderId);
                }
              }

              //this.park_btn = true;
            }
          } else {
            if (response.data.status === "errorDelivery") {
              if (status === "0") {
                this.processPayment(this.currentOrderId);
              } else {
                //this.showAlert("Delivery Order Cannot Be Amended");

                this.clearOrderState();
              }
            } else if (response.data.status === "errorShift") {
              this.showAlert(response.data.msg);
            }
          }
        }
      } catch (error) {
        console.log(error);

        this.showAlert(error);
      }
    },

    clearOrderState() {
      this.driverOrderId = "";

      this.orderItems = [];

      this.currentItem = [];

      this.clearPayments();

      this.notPaidAmount = 0;

      this.discountAmount = 0;

      this.vatAmount = 0;

      this.netTotalAmount = 0;

      this.grandTotalAmount = 0;

      this.diffAmount = 0;

      this.outstandingAmount = this.notPaidAmount.toString();

      this.dis_percentage = 0;

      this.prompMinimum_total = 0;

      this.promoDiscount = 0;

      //this.totalOrderAmount = 0;

      this.currentOrderId = "";

      // this.customer = "";

      this.currentOrderDirty = false;

      //this.orderParkStatus = "";

      this.clearLoialityData();
    },

    
    clearOrder: function () {
      this.orderItems = [];

      this.isPaymentOpen = !this.isPaymentOpen;
    },

    
    doSyncProducts: async function () {
      let alertSync = this.showInfo("Syncing...");

      try {
        let dataURL = this.apiURL + "GiftCard/syncProducts";

        let response = await axios.post(dataURL, { appId: localStorage.appId });

        if (response.data.status === "success") {
          alertSync.close();

          // Swal.fire(
          //   response.data.results + " Products Updated Successfully!",
          //   "",
          //   "success"
          // );
          Swal.fire({
            title: response.data.results + " Products Updated Successfully!",
            icon: "success",

            background: "var(--form-color)",
            color: "#fff",

            customClass: {
              title: 'my-swal-title',
              confirmButton: 'my-confirm-btn'
            }
          });
        } else {
          alertSync.close();

          this.showAlert("Sync Failed Please Retry...");
        }
      } catch (error) {
        alertSync.close();

        this.showAlert("Sync Failed Please Retry...");

        console.log(error);
      }
    },

    syncProducts() {
      Swal.fire({
        title: "Do you want to Sync Products?",
        icon: "question",
        background: "var(--form-color)",
           customClass: {
      title: 'my-swal-title',
      confirmButton: 'my-confirm-btn',
    cancelButton: 'my-cancel-btn'
    },
        // showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Sync Products",
        // denyButtonText: `No`,
        confirmButtonColor: "#28a745",
        // denyButtonColor: "#dc3545",
        cancelButtonColor: "#dc3545",
      }).then((result) => {
        if (result.isConfirmed) {
          this.doSyncProducts();
        } else if (result.isDenied) {
          Swal.fire("No Products Were Synchrinized", "", "info");
        }
      });
    },

    getProduct: async function (barcodeVar) {
      if (barcodeVar !== "") {
        try {
          //let dataURL = this.apiURL+'Products/findProduct?appId=7&barcode='+barcodeVar;

          let dataURL =
            this.apiURL +
            "Products/findProductLocal?appId=7&barcode=" +
            barcodeVar;

          let response = await axios.post(dataURL, {
            appId: localStorage.appId,
            barcode: barcodeVar,
          });

          if (response.data.status === "success") {
            this.products = response.data.results.products;

            if (this.products.length === 1) {
              let addedProduct = {};

              addedProduct.item_name = this.products[0].item_name;

              addedProduct.arabic_item_name = this.products[0].arabic_item_name;

              addedProduct.item_group = this.products[0].item_group;

              addedProduct.barcode = this.products[0].barcode;

              addedProduct.standard_rate = this.products[0].standard_rate;

              addedProduct.item_code = this.products[0].item_code;

              addedProduct.price = this.products[0].price;

              addedProduct.item_discount = 0;

              addedProduct.tax = this.products[0].tax;

              addedProduct.uom = this.products[0].uom;

              this.addProductToOrder(addedProduct);

              this.calcOrderTotalAmount();

              this.products = [];

              this.barcode = "";
              this.barcode2 = "";
            } else {
              let suffixL = this.posData.suffix_length;

              barcodeVar = barcodeVar.substring(0, barcodeVar.length - suffixL);

              let newBacode = "";

              let item_price = "";

              let item_qty = "";

              let newBacodeType = "";

              let barcodeDefLength = parseInt(
                this.posData.scale_barcode_length
              );

              let prefixQ = this.posData.prefix_barcode_qty.length;

              if (prefixQ > 0) {
                newBacodeType = barcodeVar.substring(0, prefixQ);

                newBacode = barcodeVar.substring(
                  prefixQ,
                  barcodeDefLength + prefixQ
                );

                if (newBacodeType === this.posData.prefix_barcode_qty) {
                  item_qty =
                    barcodeVar.substring(
                      barcodeDefLength + prefixQ,
                      barcodeVar.length - 1
                    ) + "0";

                  this.getNewProduct(
                    newBacode,
                    item_qty,
                    item_price,
                    newBacodeType
                  );

                  return;
                }
              }

              let prefixP = this.posData.prefix_barcode_prc.length;

              newBacodeType = barcodeVar.substring(0, prefixP);

              newBacode = barcodeVar.substring(
                prefixP,
                barcodeDefLength + prefixP
              );

              if (newBacodeType === this.posData.prefix_barcode_prc) {
                item_price = barcodeVar.substring(
                  barcodeDefLength + prefixP,
                  barcodeVar.length
                );

                this.getNewProduct(
                  newBacode,
                  item_qty,
                  item_price,
                  newBacodeType
                );
              } else if (barcodeVar === "7777777") {
                this.isNewProductOpen = true;
              } else {
                // saveBarcode
                document.activeElement.blur();
                this.showAlert("Item not found please try again");

                this.saveBarcode(barcodeVar);
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    getNewProduct: async function (
      newBarcode,
      item_qty,
      item_price,
      newBacodeType
    ) {
      try {
        let dataURL =
          this.apiURL +
          "Products/findProductLocal?appId=7&barcode=" +
          newBarcode;

        let response = await axios.post(dataURL, {
          appId: localStorage.appId,
          barcode: newBarcode,
        });

        this.products = response.data.results.products;

        if (this.products.length === 1) {
          let price = 0;

          let taxBase = 1;

          if (this.products[0].tax == "Standard") {
            taxBase = this.taxBaseAmount;
          }

          let standard_rate = parseFloat(
            Math.ceil(this.products[0].standard_rate / 100) * 100
          ).toFixed(2);

          let qty = 0;

          if (item_price !== "") {
            price = parseFloat(Math.ceil(item_price / 100) * 100).toFixed(2);

            if (standard_rate > 0) {
              qty = (item_price * 1000) / (standard_rate * 1000);
            }
          } else if (item_qty !== "") {
            qty = parseFloat(item_qty / 10000).toFixed(3);

            price = parseFloat(qty * standard_rate).toFixed(2);
          }

          this.seqId = this.seqId + 1;

          if (this.currentItem.length !== 0) {
            this.orderItems.push(this.currentItem[0]);

            this.currentItem = [];
          }

          //this.orderItems.push({"seqId":this.seqId, "item_discount":0, "item_group":this.products[0].item_group, "item_code":this.products[0].item_code,"item_name":this.products[0].item_name, "item_group":this.products[0].item_group, "barcode":newBarcode, "price":parseFloat(price).toFixed(2), "standard_rate":parseFloat(standard_rate).toFixed(2),"qty":parseFloat(qty).toFixed(3)});

          this.currentItem.push({
            taxRateName: this.products[0].tax,
            seqId: this.seqId,
            item_discount: 0,
            tax: taxBase,
            uom: this.products[0].uom,
            item_group: this.products[0].item_group,
            item_code: this.products[0].item_code,
            item_name: this.products[0].item_name,
            item_group: this.products[0].item_group,
            barcode: newBarcode,
            price: parseFloat(price).toFixed(2),
            standard_rate: parseFloat(standard_rate).toFixed(2),
            qty: parseFloat(qty).toFixed(3),
            newBacodeType: newBacodeType,
          });

          //this.addProductToOrder({"seqId":this.seqId, "item_discount":0, "item_code":this.products[0].item_code,"item_name":this.products[0].item_name, "item_group":this.products[0].item_group, "barcode":newBarcode, "price":parseFloat(price).toFixed(2), "standard_rate":parseFloat(standard_rate).toFixed(2),"qty":parseFloat(qty).toFixed(3)});

          this.calcOrderTotalAmount();

          this.products = [];

          this.barcode = "";
          this.barcode2 = "";
        } else {
          document.activeElement.blur();
          this.showAlert("Item not found please try again");

          this.saveBarcode(newBarcode);
        }
      } catch (error) {
        console.log(error);
      }
    },

    calcPromoDiscount(grandAmount) {
      let discount = 0;

      let minimum_total = 0;

      if (this.currentPromotions.length > 0) {
        minimum_total = this.currentPromotions[0].minimum_total;

        if (
          Math.round(grandAmount * 100) / 100 >=
          Math.round(minimum_total * 100) / 100
        ) {
          let amount =
            (this.currentPromotions[0].percentage * grandAmount) / 100;

          discount = parseFloat(Math.round(amount / 100) * 100).toFixed(2);
        }
      }

      return discount;
    },

    calcOrderTotalAmount: function () {
      if (this.invoiceDiscount > 0) {
      } else {
        this.discountAmount = parseInt(
          this.calcPromoDiscount(this.calcOrderNetTotal())
        );
      }
      this.netTotalAmount = parseInt(this.calcOrderNetTotal());
      this.vatAmount = parseInt(this.calcOrderVatTotal());
      this.grandTotalAmount =
      this.netTotalAmount + this.vatAmount - this.discountAmount;
      this.notPaidAmount = parseFloat(this.grandTotalAmount - this.paidAmount); // - this.creditAmount - this.balance - this.accountAmount;
    },

    calcOrderNetTotal: function () {
      let orderAmount = 0;

      if (this.orderItems.length > 0) {
        this.orderItems.forEach(function (order) {
          let price = order.standard_rate / order.tax;

          orderAmount = orderAmount + Math.round(price * order.qty);
        });
      }

      if (this.currentItem.length > 0) {
        this.currentItem.forEach(function (order) {
          let price = order.standard_rate / order.tax;

          orderAmount = orderAmount + Math.round(price * order.qty);
        });
      }

      return orderAmount;
    },

    calcOrderVatTotal: function () {
      let orderVatAmount = 0;

      if (this.orderItems.length > 0) {
        this.orderItems.forEach(function (order) {
          if (order.tax == 1) return;

          let newStandardRate = order.standard_rate / order.tax;

          let newPrice = newStandardRate * order.qty;

          let vatAmount = order.price - newPrice;

          orderVatAmount += Math.round(vatAmount);
        });
      }

      if (this.currentItem.length > 0) {
        this.currentItem.forEach(function (order) {
          if (order.tax == 1) return;

          let newStandardRate = order.standard_rate / order.tax;

          let newPrice = newStandardRate * order.qty;

          let vatAmount = order.price - newPrice;

          orderVatAmount += Math.round(vatAmount);
        });
      }

      return orderVatAmount;
    },

    calcOrderDiscount: function () {
      let dis = 0;

      if (this.discountAmount !== 0) {
        dis = this.discountAmount;
      } else {
        let promoDis = 0;

        if (this.prompMinimum_total <= this.netTotalAmount) {
          if (this.orderItems.length > 0) {
            this.orderItems.forEach(function (order) {
              if (
                order.item_discount != null &&
                order.item_discount !== undefined
              ) {
                promoDis =
                  promoDis +
                  (parseFloat(order.item_discount) * order.price) / 100;
              }
            });
          }

          if (this.currentItem.length > 0) {
            this.currentItem.forEach(function (order) {
              if (
                order.item_discount != null &&
                order.item_discount !== undefined
              ) {
                promoDis =
                  promoDis +
                  (parseFloat(order.item_discount) * order.price) / 100;
              }
            });
          }
        }

        dis = promoDis;

        let persDis = 0;

        if (this.dis_percentage > 0) {
          persDis = this.netTotalAmount * (this.dis_percentage / 100);
        }

        if (persDis > promoDis) {
          dis = persDis;
        }
      }

      return dis;
    },

    addProductToOrder: function (product) {
      this.changeAmount = 0;

      this.showChange = false;

      if (this.orderItems.length > 0) {
        this.seqId = parseInt(this.orderItems[0].seqId) + 1;
      }

      let taxBase = 1;

      if (this.currentItem.length === 0) {
        if (product.tax == "Standard") {
          taxBase = this.taxBaseAmount;
        }

        this.currentItem.push({
          seqId: this.seqId,

          barcode: product.barcode,

          item_code: product.item_code,

          item_name: product.item_name,

          taxRateName: product.tax,

          item_group: product.item_group,

          standard_rate: parseFloat(product.standard_rate).toFixed(2),

          price: parseFloat(product.standard_rate).toFixed(2),

          qty: 1,

          uom: product.uom,

          tax: taxBase,

          item_dis_price: product.item_dis_price,

          item_discount: product.item_discount,
        });

        this.calcOrderTotalAmount();
      } else {
        let tempOrderItems = [];

        tempOrderItems = this.orderItems.filter(function (a) {
          if (product.barcode !== null) {
            if (a.barcode.toLowerCase() === product.barcode) {
              return true;
            }
          }

          return false;
        });

        if (tempOrderItems.length > 0) {
          for (var i = 0; i < this.orderItems.length; i++) {
            if (this.orderItems[i].barcode === product.barcode) {
              let newItem = this.orderItems[i];
              newItem.qty = this.orderItems[i].qty + 1;
              newItem.price =
                newItem.qty *
                parseFloat(this.orderItems[i].standard_rate).toFixed(2);

              this.orderItems.splice(i, 1);

              this.orderItems.push(this.currentItem[0]);

              this.currentItem = [];

              this.currentItem.push(newItem);
            }
          }

          this.calcOrderTotalAmount();
        } else {
          if (product.barcode === this.currentItem[0].barcode) {
            this.currentItem[0].qty = this.currentItem[0].qty + 1;

            this.currentItem[0].price =
              this.currentItem[0].standard_rate * this.currentItem[0].qty;

            this.calcOrderTotalAmount();
          } else {
            if (product.tax == "Standard") {
              taxBase = this.taxBaseAmount;
            }

            this.seqId = this.seqId + 1;

            this.orderItems.push(this.currentItem[0]);

            this.orderItems.reverse();
            this.orderItems.reverse();
            this.currentItem = [];
            this.currentItem.push({
              seqId: this.seqId,
              item_code: product.item_code,
              item_group: product.item_group,
              item_name: product.item_name,
              barcode: product.barcode,
              taxRateName: product.tax,
              uom: product.uom,
              standard_rate: parseFloat(product.standard_rate).toFixed(2),
              price: parseFloat(product.standard_rate).toFixed(2),
              tax: taxBase,
              qty: 1,
              item_discount: product.item_discount,
            });

            this.calcOrderTotalAmount();
          }
        }
      }
      this.currentOrderDirty = true;
      this.orderItems.sort((a, b) => Number(b.seqId) - Number(a.seqId));
    },
  },

  setup() {
    const isOpen = ref(false);

    const isPaymentOpen = ref(false);

    const isLoyalityOpen = ref(false);

    const isGiftCardOpen = ref(false);

    const isVoidOpen = ref(false);

    const isVoidOrderOpen = ref(false);

    const isCheckPriceOpen = ref(false);

    const isNewProductOpen = ref(false);

    //const isKeyboardOpen = ref(false);

    const isKeypadOpen = ref(false);

    const isPayCashOpen = ref(false);

    const isPayCreditOpen = ref(false);

    const isPayMobileOpen = ref(false);

    const isChangePasswordOpen = ref(false);

    const isPayAccountOpen = ref(false);

    const isCloseCashOpen = ref(false);

    const isShowInfosOpen = ref(false);


    const totalPaymentAmount = ref(Number);

    let orderItems = ref(Array);

    const orderId = ref(String);

    const customernumber = ref(String);

    return {
      isOpen,
      isPaymentOpen,
      totalPaymentAmount,
      isLoyalityOpen,
      isGiftCardOpen,
      isVoidOpen,
      isVoidOrderOpen,
      isKeypadOpen,
      isCheckPriceOpen,
      isPayCashOpen,
      isPayCreditOpen,
      isPayMobileOpen,
      isPayAccountOpen,
      isCloseCashOpen,
      isShowInfosOpen,
      isNewProductOpen,
      isChangePasswordOpen
    };
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;

  -webkit-font-smoothing: antialiased;

  -moz-osx-font-smoothing: grayscale;

  text-align: left;

  color: #2c3e50;

  margin-top: 20px;

  /*overflow-y: hidden;*/
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;

  text-decoration: none;

  background-color: #eeeeee;

  color: #333333;
  border-radius: 10px;
  margin-bottom: 5px;
}

.grid-container-element {
  display: grid;

  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;

  grid-gap: 10px;

  border: 1px solid whitesmoke;

  border-left: 0px;

  border-right: 0px;

  border-top: 0px;

  width: 100%;
}

.grid-child-element_ {
  margin: 10px;

  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;

  border-left: 0px;

  border-right: 0px;

  border-top: 0px;

  padding: 0 px;
}

.swal2-title {
  font-family: monospace !important;

  color: red;
}

.numberCircleGreen {
  border-radius: 50%;

  width: 36px;

  height: 36px;

  padding: 8px;

  background: green;

  border: 2px solid #666;

  color: #666;

  text-align: center;

  font: 32px Arial, sans-serif;
}

.numberCircleRed {
  border-radius: 50%;

  width: 36px;

  height: 36px;

  padding: 8px;

  background: red;

  border: 2px solid #666;

  color: #666;

  text-align: center;

  font: 32px Arial, sans-serif;
}

.circle {
  border: 0.1em solid grey;

  border-radius: 100%;

  height: 1.5em;

  width: 1.5em;

  text-align: center;

  background: red;
}

.circle p {
  margin-top: 0.1em;

  font-size: 1em;

  font-weight: bold;

  font-family: sans-serif;

  color: grey;

  background: red;
}

#menu .list-group-item {
  padding: 5px 0px;
}

.parked-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 30px 15px;
  min-height: 680px;
}

.parked-spinner {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: var(--theme-primary);
  animation: parked-spin 1s linear infinite;
}

@keyframes parked-spin {
  to {
    transform: rotate(360deg);
  }
}

.my-swal-title {
  color: var(--theme-text-main) !important;   /* تغيير اللون */
  font-size: 22px !important;  /* تكبير الخط */
  font-family: monospace;
}
.my-confirm-btn {
  font-size: 14px !important;
  padding: 10px 20px !important;
}

.my-cancel-btn {
  font-size: 14px !important;
  padding: 10px 20px !important;
}
</style>
